import { useAuth } from '../providers/AuthProvider';

export default function useInternal() {
  const { currentUser } = useAuth();
  if (!currentUser) return false;
  return (
    [
      1, 2, 4, 7, 16, 49, 17040, 20601, 22597, 14719, 23875, 22465, 22462, 22461, 20601, 31872, 10389, 30559, 24610,
      52487, 54132, 51967, 45837, 52409, 2288, 38084, 63515, 6524,
    ].indexOf(currentUser.id) !== -1
  );
}
